import { render, staticRenderFns } from "./OrganisationEditAction.vue?vue&type=template&id=01f66d42"
import script from "./OrganisationEditAction.vue?vue&type=script&lang=js"
export * from "./OrganisationEditAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports